import { Card, Heading, Metric, Text } from "@/design-system";
import { BENEFITS, METRICS } from "../constants";

/** O que a farmácia ganha ao ser indicada: três benefícios e três números. */
export const PartnerBenefits = () => (
  <section
    aria-labelledby="beneficios-title"
    className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 sm:px-6 lg:px-8"
  >
    <div className="flex max-w-2xl flex-col gap-3">
      <Heading level={2} id="beneficios-title">
        O que a farmácia ganha com a Fidexa
      </Heading>
      <Text size="lead" tone="muted">
        Marketing, atendimento e cobrança pelo WhatsApp oficial, sem depender
        de número pessoal.
      </Text>
    </div>

    <ul className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {BENEFITS.map(benefit => (
        <li key={benefit.title}>
          <Card className="flex h-full flex-col gap-2">
            <Heading level={3}>{benefit.title}</Heading>
            <Text tone="muted">{benefit.description}</Text>
          </Card>
        </li>
      ))}
    </ul>

    <ul
      aria-label="Números públicos da Fidexa"
      className="border-ds-border grid gap-6 border-t pt-8 sm:grid-cols-3"
    >
      {METRICS.map(metric => (
        <li key={metric.label}>
          <Metric value={metric.value} label={metric.label} hint={metric.hint} />
        </li>
      ))}
    </ul>
  </section>
);
